module.exports = __webpack_public_path__ + "img/Leuze Electronic.55ee7415.png";